<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Choose a Pro</div>
    </template>

    <div class="d-flex flex-column" style="width: 100%">
      <ProsInput
        v-model="pros" 
        :service="currentService" 
        :zipcode="currentRequest.zipcode"
        :structure_type="currentRequest.structure_type"
      />
    </div>
    <Section>
      <v-btn :disabled="pros.length < 1" color="primary" @click="recommendClick">
        {{ pros.length > 0 ? 'Recommend' : 'Choose a Pro' }}
      </v-btn>
    </Section>
  </ContentPage>
</template>


<script>
  import { ContentPage, Section } from '@/components/pages'
  import { ProsInput } from '@/components/inputs'
  import { mapActions, mapGetters } from 'vuex'


  export default {
    name: 'ReferralsPro',
    
    components: { ProsInput, ContentPage, Section },

    data: () => ({
      pros: [],
    }),

    computed: {
      ...mapGetters('referrals', {
        currentService: 'currentServiceID',
        currentRequest: 'currentRequest',
      }),
    },

    methods: {
      ...mapActions('referrals', ['setCurrentPros']),

      recommendClick() {
        this.setCurrentPros(this.pros)
        this.$router.push({ name: 'referrals/confirm' })
      }
    },
  }
</script>